import { Component, OnInit, OnChanges, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import { DeliPriceService } from '../../../service/deli-price/deli-price.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { PrefService } from '../../../service/pref/pref.service';
import { SizeService } from '../../../service/size/size.service';
import { WeightService } from '../../../service/weight/weight.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'wa9181',
  templateUrl: './wa9181.component.html',
  styleUrls: ['./wa9181.component.scss']
})
export class Wa9181Component implements OnInit, OnChanges {
  public componentTitle = 'WA9181:運送料マスタ登録';

  public owners: any;
  public owner: any;
  public carriers: any;
  public notchargeFl: number;
  public prefs: any;
  public sizes: any;
  public weights: any;

  public ownerId: number;
  public carrierCd: string;
  public prefCd: string;
  public sizeCd = new FormControl('');
  public weightCd = new FormControl('');
  public priceNr: number;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() selectedOwnerId;
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;
  private isShowRemoveModal = false;
  private ownerCls = '';
  private priceNrCls = '';
  private carrierCdCls = '';
  private prefCdCls = '';
  private sizeCdCls = '';
  private weightCdCls = '';

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private deliPriceService: DeliPriceService,
    private prefService: PrefService,
    private sizeService: SizeService,
    private weightService: WeightService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private carrierService: CarrierService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onView() {
    this.owners = [];
    // this.ownerService
    //   .get()
    //   .then(outputJson => {
    //     console.log(JSON.parse(sessionStorage.getItem('ownerResult')).ownerId);
    //     this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
    //     if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {
    //       this.owners = outputJson.owners.filter((item, index) => {
    //         if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
    //       });
    //       this.ownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
    //     } else {
    //       this.owners = outputJson.owners;
    //       this.selectedOwnerId = null;
    //       this.ownerId = null;
    //     }
    //   })
    //   .catch(error => {
    //     this.errorInfo = this.commonService.getErrorMessage(error);
    //   });

    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.prefService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.prefs.push({ prefCd: '', prefTx: '選択しない' });
        this.prefs = __outputJson.prefs;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  changeCarrier() {
    this.errorInfo = '';

    this.sizeService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.sizes.push({ carrierTx: '-', delisizeCd: '', delisizeTx: '選択しない' });
        this.sizes = __outputJson.sizes;
        this.sizeCd.setValue('');
        this.sizeCdCls = '';
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.weightService
      .get(this.carrierCd)
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.weights.push({ carrierTx: '-', deliweightCd: '', deliweightTx: '選択しない' });
        this.weights = __outputJson.weights;
        this.weightCd.setValue('');
        this.weightCdCls = '';
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  changeWeight() {
    if (this.weightCd.value == 'X1') this.sizeCd.setValue('');
  }

  onSubmit() {
    if (!this.isSubmitButtonEnabled) return;

    if (this.ownerId == null) {
      this.errorInfo = '荷主名を選択してください';
      return;
    }
    if (this.carrierCd === '') {
      this.errorInfo = '配送会社を選択してください';
      return;
    }
    if (Number(this.notchargeFl) === 1) {
      this.isShowRemoveModal = true;
      // this.dialogsService.confirm('注意', '対象[荷主+配送会社]で登録したその他の送料設定は削除されます。よろしいですか？').subscribe(res => {
      //   if (res === true) {
      //     this.prefCd = '-';
      //     this.sizeCd = '-';
      //     this.weightCd = '-';
      //     this.priceNr = 0;
      //     this.postDeliPrice();
      //   }
      // });
    } else {
      if (this.weightCd.value === 'X1' && this.sizeCd.value !== '') {
        this.errorInfo = 'サイズと重量を正しく選択してください';
        return;
      }
      if (this.priceNr < 0 || this.priceNr > 9999999) {
        this.errorInfo = '配送料は9999999より小さい数字で入力してください';
        return;
      }
      this.notchargeFl = 0;
      this.postDeliPrice();
    }
  }

  confirmOk() {
    this.isShowRemoveModal = false;
    this.prefCd = '-';
    this.sizeCd.setValue('-');
    this.weightCd.setValue('-');
    this.priceNr = 0;
    this.postDeliPrice();
  }

  postDeliPrice() {
    this.working = true;
    this.deliPriceService
      .post(
        this.ownerId,
        this.carrierCd,
        Number(this.notchargeFl),
        this.prefCd ? this.prefCd : '-',
        this.sizeCd.value ? this.sizeCd.value : '-',
        this.weightCd.value ? this.weightCd.value : '-',
        this.priceNr,
        'wa9181'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  ngOnChanges() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.selectedOwnerId = undefined;
        if (sessionStorage.getItem('ownerResult'))
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
        if (this.selectedOwnerId) {
          this.owners = outputJson.owners.filter((item, index) => {
            if (item.ownerId === this.selectedOwnerId) return true;
          });
          this.ownerId = this.selectedOwnerId;
        } else {
          this.owners = outputJson.owners;
          this.ownerId = null;
        }
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.errorInfo = '';
    this.ownerId = null;
    this.carrierCd = '';
    this.prefCd = '';
    this.sizeCd.setValue('');
    this.weightCd.setValue('');
    this.priceNr = null;
    this.notchargeFl = 0;

    this.isSubmitButtonEnabled = false;

    this.ownerCls = '';
    this.priceNrCls = '';
    this.carrierCdCls = '';
    this.prefCdCls = '';
    this.sizeCdCls = '';
    this.weightCdCls = '';
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  onRadioGroupChange() {
    this.checkUpdateButtonState();
  }

  checkUpdateButtonState() {
    if (this.owners.length == 1) {
      this.ownerCls = 'disabled';
    }
    if (this.owners.length > 1) {
      this.isSubmitButtonEnabled = this.ownerCls == 'active' && this.carrierCdCls === 'active' && (this.notchargeFl == 1 || this.priceNrCls === 'active');
    } else {
      this.isSubmitButtonEnabled = this.carrierCdCls === 'active' && (this.notchargeFl == 1 || this.priceNrCls === 'active');
    }
  }

  ngDoCheck() {
    if (!this.isShow) return;

    if (this.carrierCd == '') {
      this.sizeCd.disable();
      this.weightCd.disable();
      this.sizeCdCls = 'disabled';
      this.weightCdCls = 'disabled';
    } else {
      this.sizeCd.enable();
      this.weightCd.enable();
      this.sizeCdCls = '';
      this.weightCdCls = '';
    }

    this.priceNrCls = this.priceNr == null ? '' : (this.priceNr + '').length == 0 ? 'error' : 'active';
    this.ownerCls = this.owners.length !== 1 ? (this.ownerId == null || this.ownerId + '' === 'null' ? '' : (this.ownerId + '').length == 0 ? 'error' : 'active') : '';
    this.carrierCdCls = this.carrierCd == '' ? '' : 'active';
    this.prefCdCls = this.prefCd == '' ? '' : 'active';
    this.sizeCdCls = this.sizeCdCls == 'disabled' ? 'disabled' : this.sizeCd.value == '' ? '' : 'active';
    this.weightCdCls = this.weightCdCls == 'disabled' ? 'disabled' : this.weightCd.value == '' ? '' : 'active';

    this.checkUpdateButtonState();
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9181/wa9181.component.ts